<div class="confirm-modal ig-modal edit-event-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">CONTACT US</div>

    <p class="tip">If you are looking to utilize one of the ImGoing features not yet available in your account, please contact our
        team, emailing <a href="mailto:aline@iti-digital.com">aline@iti-digital.com</a> or call us at 912-267-1558</p>

    <div class="cancel-btn pointer" (click)="close()">
        OK
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/upgrade.modal/upgrade.modal.component.html